import { ReactElement } from 'react';

/**
 * HelpCenter page to Show guide user for their Queries.
 * @returns - HelpCenter Page.
 */
export default function HelpCenter(): ReactElement {
  return <div>helpCenter.page</div>;
}
